export default __webpack_public_path__ + "static/media/mp-cartao.b8f41bf1.svg";